import { useState } from 'react';
import { LogIn } from 'lucide-react';
import { Button } from '@/shared/ui/button';
import type { PublicInvitePassbook, RegisterInviteResult } from '@/features/public-invite/api/use-public-invite';
import { PublicInviteDuplicate } from '@/features/public-invite/ui/public-invite-duplicate';
import { PublicInviteSuccess } from '@/features/public-invite/ui/public-invite-success';
import { PublicInviteWizard } from '@/features/public-invite/ui/public-invite-wizard';

interface ParticipantRegisterProps {
  passbook: PublicInvitePassbook;
  campanha?: string;
  /** Depois do cadastro (ou de "já tem cadastro"), leva para Entrar. */
  onGoToLogin: () => void;
}

/** Bolinha Cadastro: o cadastro público de hoje, sem mudar regra, com a saída para a conta. */
export function ParticipantRegister({ passbook, campanha, onGoToLogin }: ParticipantRegisterProps) {
  const [result, setResult] = useState<RegisterInviteResult | null>(null);

  const followUp = (
    <div className="mx-auto mt-4 flex max-w-md flex-col items-center gap-2 text-center">
      <p className="text-sm text-muted-foreground">Acompanhe seus pontos, cupons e dados por aqui.</p>
      <Button variant="outline" onClick={onGoToLogin}>
        <LogIn className="size-4" />
        Acompanhar minha conta
      </Button>
    </div>
  );

  if (result?.status === 'created') {
    return (
      <>
        <PublicInviteSuccess passbook={passbook} serialNumber={result.serialNumber} />
        {followUp}
      </>
    );
  }

  if (result?.status === 'duplicate') {
    return (
      <>
        <PublicInviteDuplicate email={result.email} />
        {followUp}
      </>
    );
  }

  return <PublicInviteWizard passbook={passbook} campanha={campanha} onSuccess={setResult} />;
}
